import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { CopyService } from '@amfam/shared/utility/shared-services';
import { ConfirmationModel } from '@amfam/ui-kit';

@Component({
  selector: 'ds-add-payment-method-success-modal',
  templateUrl: './add-payment-method-success-modal.component.html',
  standalone: false
})
export class AddPaymentSuccessModalComponent implements OnInit {
  @Output() closeAddPaymentMethodSuccessModalEvent: EventEmitter<void> = new EventEmitter<void>();

  public confirmationData!: ConfirmationModel;

  constructor(
    private store: Store,
    private copyService: CopyService
  ) {}

  ngOnInit() {
    this.confirmationData = {
      confirmation: {
        heading: this.copyService.getCopy('billing.addPaymentMethodSuccessHeading'),
        infoText: this.copyService.getCopy('billing.addPaymentMethodSuccessSubHeading')
      },
      ctaArea: {
        button: {
          title: 'Continue',
          callback: this.handleClose.bind(this)
        }
      }
    };
  }

  handleClose(): void {
    this.closeAddPaymentMethodSuccessModalEvent.emit();
  }
}
